/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReceiptRequest } from '../../models/receipt-request';

export interface ApiRequestReceiptGetRequestByIdGet$Params {
  id?: string;
}

export function apiRequestReceiptGetRequestByIdGet(http: HttpClient, rootUrl: string, params?: ApiRequestReceiptGetRequestByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptRequest>> {
  const rb = new RequestBuilder(rootUrl, apiRequestReceiptGetRequestByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptRequest>;
    })
  );
}

apiRequestReceiptGetRequestByIdGet.PATH = '/api/Request/Receipt/GetRequestById';
